// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1Z3NA","ranges":"BmiRanges_ranges__2SKbH"};